import { render, staticRenderFns } from "./LensConnectionLostModal.vue?vue&type=template&id=2b3f1563&scoped=true"
import script from "./LensConnectionLostModal.vue?vue&type=script&lang=js"
export * from "./LensConnectionLostModal.vue?vue&type=script&lang=js"
import style0 from "./LensConnectionLostModal.vue?vue&type=style&index=0&id=2b3f1563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3f1563",
  null
  
)

export default component.exports